import React  from 'react';
import { Menu,Button, Item} from 'semantic-ui-react'
import {SearchSelect} from '@wollo-lib/wollo-react'
import {useHistory, useLocation} from 'react-router-dom'
import {useShopContext} from './ShopContext'

const SearchItem=(props)=>
{
    const  {searchWidth,db}=props
    const history= useHistory()

    const renderSearch=({ title,value })=> (
        <Item  key={value} style={{color:'black'}} >{title}</Item>
    )
    const handleChange=(e,{value,result})=>
    {
        if(result.typ==='Kunde')
            history.push(`/show/kunde/${value}`)
        else if(result.typ==='Paket')
            history.push(`/show/paket/${value}`)
    }
    
    return (
         <Menu.Item key={99} position='right' >
             <SearchSelect
                style={{"width":searchWidth}}
                fluid
                category
                resultRenderer={renderSearch}
                name='search' 
                onChange={handleChange} 
                placeholder={'Kundenname oder Paketnummer'}
                Value2TitleUrl={{Kunde:{table: db.users, field: 'UID', map: el=>(`${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`)},
                    Paket: { table: db.pakete, field: 'Paketnummer', map: el=>(`${el.Paketnummer}`)}} }
                SuggestDexie={
                                {
                                    Kunde:{ 
                                        table: db.users,
                                        field:'fulltext', 
                                        map: el=> ({
                                                        key:el.UID, 
                                                        title:`${el.Vorname} ${el.Nachname} ${el.PLZ} ${el.Ort}`, 
                                                        value: el.UID, 
                                                        typ:'Kunde'})},
                                    Paket:{ 
                                        table: db.pakete,
                                        field: 'Paketnummer',
                                        map: el=> ({
                                                    key:el.UID,
                                                    title:`${el.Paketnummer}`, 
                                                    value: el.UID, 
                                                    typ:'Paket'
                                                    })
                                            }
                                }
                            }    
                api='back'
                autoClear
                autoSelect
            />

        </Menu.Item>
    )
}
 
const SyncStatus=(props)=>
{
    const history= useHistory()
    const location = useLocation();

   

    const {syncStatus,db,time,recreateDB}=props


    const maintenance=()=>
    {
        history.push('/Maintenance')
    }
    


    switch(syncStatus)
    {
        case 'ONLINE':
        case 'SYNCING': 

                return <Button icon circular  color='green' icon='sync' onClick={maintenance}/>
                break
        case 'ERROR': 
        case 'ERROR_WILL_RETRY':
            
           
            return <span><Button circular color='red' icon='times' onClick={maintenance}/>time</span>
            break
        case 'CONNECTING': 
        case 'PREPARING': 

            return <Button circular color='yellow' icon='sync' onClick={maintenance}/>
            break
        case 'OFFLINE': 

            return <Button circular color='red' icon='sync' onClick={maintenance}/>
            break
        default:

            return syncStatus
    }
}

const MainMenu=(props)=>
{
  
    const history=useHistory()
 

 
   
  
    return (
    <>

            <Menu attached='top' color='yellow' inverted>
                <Menu.Item icon='bars' onClick={el=>{history.push('/')}} />
                   
                <SearchItem {...props} searchWidth='260px' />  
                <SyncStatus {...props} />         
            </Menu>

     
    </>
    


    )
}
export default MainMenu
